import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import 'chartjs-adapter-moment';
import { Chart as ChartJS, registerables } from "chart.js";
import zoomPlugin from "chartjs-plugin-zoom";
// -
import { AlertsChartsParams } from "site-apps/alerts/AlertsTypesCharts";


ChartJS.register(...registerables, zoomPlugin);


const LinearScatterChart = ({ fillings, title, alerts, chartRef, options }) => {
    const [_Tc] = useTranslation("choices")
    const [datasets, setDataSets] = useState({ labels: [], datasets: [] });

    const createScatterAlert = (key, data) => {
        return {
            type: "scatter",
            label: _Tc(AlertsChartsParams[key].title),
            data: data,
            backgroundColor: AlertsChartsParams[key].backgroundColor,
            borderColor: AlertsChartsParams[key].borderColor,
            borderWidth: 2,
            pointRadius: 3,
        };
    }
    const createScatterLine = (key, data) => {
        /*
        plugins: {
        legend: {
            labels: {
                // Filtramos qué etiquetas mostrar en la leyenda
                generateLabels(chart) {
                    const labels = Chart.defaults.plugins.legend.labels.generateLabels(chart);
                    // Filtramos y excluimos el dataset con este label
                    return labels.filter((label) => label.text !== "Ocultar de la leyenda");
                },
            },
        },
    },

         */
        let coords = [];
        let lines = [];
        data.forEach((item) => {
            coords.push([
                { x: item.x, y: 0 },
                { x: item.x, y: 100 }
            ])
        })
        coords.forEach((coord) => {
            lines.push({
                type: "line",
                title: "",
                data: coord,
                backgroundColor: AlertsChartsParams[key].backgroundColor,
                borderColor: AlertsChartsParams[key].borderColor,
                borderWidth: 1,
                pointRadius: 0,
                display: false
            })
        })
        return lines
    }
    const createLine = (data) => {
        return {
            type: "line",
            label: title,
            data: data,
            backgroundColor: 'rgb(0,151,255, 0.5)',
            borderColor: 'rgb(82,161,251)',
            borderWidth: 2,
            pointRadius: 2,
            tension: 0,
        };
    }

    useEffect(() => {
        let timeStamp = [];
        let fillings_ = [];
        // -
        fillings.forEach((item) => {
            timeStamp.push(item[0] * 1000);
            fillings_.push(item[1]);
        })
        let dataChart = [];
        dataChart.push(createLine(fillings_));
        // -
        Object.keys(alerts).forEach((key) => {
            if (alerts[key].length) {
                dataChart.push(createScatterAlert(key, alerts[key]));
                //dataChart.push(...createScatterLine(key, alerts[key]));
            }
        })
        // -
        setDataSets({ labels: timeStamp, datasets: dataChart });
    }, [fillings, alerts]);

    return (
        <Line ref={chartRef} data={datasets} options={options} />
    )
}

export default LinearScatterChart;